/**
 * Базовый адрес API (шлюз super-smm).
 *
 * Раньше половина кода читала VITE_API_BASE_URL, половина зашивала адрес строкой.
 * `.env.production` подхватывается только при `vite build`, а `.env` гитигнорится —
 * поэтому в dev переменной нет, и запросы уезжали на `undefined/oauth/...`.
 * Дефолт = прод-шлюз: dev работает из коробки, а подменить адрес (локальный бэк,
 * стенд) по-прежнему можно через VITE_API_BASE_URL в .env.
 */
const FALLBACK_API_BASE = 'https://vkboss-light.super-smm.com/api/vkboss';

const configured = (import.meta.env.VITE_API_BASE_URL || '').trim().replace(/\/+$/, '');

export const API_BASE = configured || FALLBACK_API_BASE;

/** Адрес ручки API: `apiUrl('/user')` → `<база>/user`. */
export const apiUrl = (path: string): string => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
